import {ApplicationConfig, provideZoneChangeDetection, importProvidersFrom} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {of} from 'rxjs';
import {directRoutes} from './app-direct-routing.module';
import {UsanaCurrencyPipe} from './modules/currency/usana-currency.pipe';

/**
 * Mock for UsanaCurrencyPipe.
 * The real pipe has deep dependencies (AppConfigService → GqlAppConfigService → Apollo).
 * TranslateService injects it but only uses it for currency formatting in translations,
 * which this minimal direct component doesn't need.
 */
const MockUsanaCurrencyPipe = {
    transform: (value: any) => of(value?.toString() ?? '')
};

/**
 * Application configuration for standalone /direct routes.
 * Minimal config - avoids loading Apollo/GraphQL dependencies.
 */
export const directConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(directRoutes),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        importProvidersFrom(LoggerModule.forRoot({level: NgxLoggerLevel.ERROR})),

        {provide: UsanaCurrencyPipe, useValue: MockUsanaCurrencyPipe},
    ]
};

